/**
 * Navbar
 */

// import debounce from 'lodash/debounce';
import throttle from "lodash/throttle";

const throttleTime = 200;

export default function navbar() {
  const navbar = document.querySelector("[data-js='navbar']");
  const navbarMobScroll = document.querySelector(
    "[data-js='navbar-mob-scroll']"
  );

  // When Navbar exists
  if (navbar) {
    // Navbar becomes fixed to bottom on mobile devices.
    var pageWidthFixed = function () {
      const navbarWidth = 992;

      window.addEventListener("load", function () {
        if (window.innerWidth < navbarWidth) {
          navbar.classList.add("fixed-to-bottom");
        } else {
          navbar.classList.remove("fixed-to-bottom");
        }
      });

      window.addEventListener("resize", function () {
        if (window.innerWidth < navbarWidth) {
          navbar.classList.add("fixed-to-bottom");
        } else {
          navbar.classList.remove("fixed-to-bottom");
        }
      });
    };
    pageWidthFixed();

    // Show an overlay on the navbar toggler click.
    var trigger = function () {
      document.addEventListener(
        "click",
        function (e) {
          if (e.target.closest("[data-js='navbar-toggler']")) {
            e.preventDefault();
            document.body.classList.toggle("navbar--opened");
            $("[data-toggle='popover']").popover("hide");
            $("#modal-backdrop").removeClass("modal-backdrop show");
          }
        },
        false
      );
    };
    trigger();

    // fix for closed menu when turning back.
    $(".navbar__link").on("click", function () {
      $("body").removeClass("navbar--opened");
    });

    $(".navbar").hide().delay(600).fadeIn(200);

    // Navbar becomes transparent when scrolling down.
    var onScrollTransparent = function () {
      const navbarPixels = 150;

      if (navbar.classList.contains("navbar--fixed-transparent")) {
        function navbarTransparent() {
          let scrolled = document.scrollingElement.scrollTop;
          let position = navbar.offsetTop;
          if (scrolled > position + navbarPixels) {
            navbar.classList.add("navbar--scrolled");
          } else {
            navbar.classList.remove("navbar--scrolled");
          }
        }
        window.addEventListener(
          "scroll",
          throttle(navbarTransparent, throttleTime)
        );
      }
    };
    onScrollTransparent();

    // Navbar slides out of view when scrolling down and slides back
    // in when scrolling up
    // Based on
    // https://dev.to/changoman/showhide-element-on-scroll-w-vanilla-js-3odm
    if (navbarMobScroll) {
      var onScrollToggle = function () {
        const navbarPixels = 150;
        let scrollPos = 0;

        if (navbarMobScroll.classList.contains("navbar--fixed-toggle")) {
          function navbarShowHide() {
            var scrolled = document.scrollingElement.scrollTop;
            var position = navbarMobScroll.offsetTop;
            if (scrolled > position + navbarPixels) {
              let windowY = window.scrollY;
              if (windowY < scrollPos) {
                // Scrolling UP
                navbarMobScroll.classList.add("navbar-visible");
                navbarMobScroll.classList.remove("navbar-hidden");
              } else {
                // Scrolling DOWN
                navbarMobScroll.classList.add("navbar-hidden");
                navbarMobScroll.classList.remove("navbar-visible");
              }
              scrollPos = windowY;
            }
          }
          window.addEventListener(
            "scroll",
            throttle(navbarShowHide, throttleTime)
          );
        }
      };
      onScrollToggle();
    }

    if (window.innerWidth < 992) {
      ("use strict");

      let c,
        currentScrollTop = 0,
        navbarBottomMenu = $(".navbar-sidenavi"),
        navbarBottomMenuIcon = $(".navbar");

      // console.log(navbarBottomMenuIcon);

      $(window).scroll(function () {
        let a = $(window).scrollTop();
        let b = navbarBottomMenu.height();
        let d = navbarBottomMenuIcon.height();

        currentScrollTop = a;

        if (c < currentScrollTop && a > b + b) {
          navbarBottomMenu.addClass("scrollUp");
        } else if (c > currentScrollTop && !(a <= b)) {
          navbarBottomMenu.removeClass("scrollUp");
        }

        if (c < currentScrollTop && a > d + d) {
          navbarBottomMenuIcon.addClass("scrollUp");
        } else if (c > currentScrollTop && !(a <= d)) {
          navbarBottomMenuIcon.removeClass("scrollUp");
        }
        c = currentScrollTop;
      });
    }
  }
}

// $(document).ready(function() {
// 	$('body').removeClass('navbar--opened');
// 	$('body').addClass('horst');
// });
